import { Link } from "react-router";
import { BrandLogo } from "@rekati/ui";
import { cn } from "@rekati/utils";
import { IFORTE_LOGO } from "../../assets/brand";
import { useI18n } from "../../content/i18n";
import { useBrandQuery } from "../event/queries";
import { LanguageToggle } from "./LanguageToggle";

/** The organiser's mark on the left, the language and the way back on the right. */
export function SiteHeader({ className, right }: { className?: string; right?: React.ReactNode }) {
  const { t } = useI18n();
  const brand = useBrandQuery().data;
  return (
    <header
      className={cn(
        "relative z-10 flex items-center justify-between gap-4 px-5 py-4 sm:px-8 sm:py-6",
        className,
      )}
    >
      <Link
        to="/"
        className="-m-1 rounded-sm p-1"
        aria-label={brand?.organizer_name ? `${brand.organizer_name}: home` : "Home"}
      >
        <BrandLogo
          src={brand?.organizer_logo_url || brand?.organizer_logo_dark_url}
          fallbackSrc={IFORTE_LOGO}
          name={brand?.organizer_name || "iForte"}
          className="h-6 sm:h-7"
          textClassName="text-base font-bold"
        />
      </Link>
      <div className="flex items-center gap-2 sm:gap-3">
        {right}
        <LanguageToggle label={t("meta.language")} />
      </div>
    </header>
  );
}
